import {
    FormControlLabel,
    FormGroup,
    Switch as MuiSwitch,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { SwitchProps as MuiSwitchProps } from "@material-ui/core/Switch";
import { useField } from "formik";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            placementStart: {
                marginLeft: 0,
            },
            switch: {
                position: "relative",
                top: "3px",
            },
            negativeBar: {
                backgroundColor: "#ff9394",
            },
            negativeChecked: {
                color: "#ff6c78",
            },
        }),
    { name: "RelodeSwitch" }
);

interface SwitchProps {
    label: string;
    labelPlacement?: "bottom" | "top" | "end" | "start" | undefined;
    onSwitchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    id: string;
    disabled?: boolean;
    negative?: boolean;
}

export const SwitchField = (props: SwitchProps & MuiSwitchProps) => {
    const {
        label,
        labelPlacement,
        onSwitchChange,
        id,
        disabled,
        negative = false,
        name = props.id,
        ...muiSwitchProps
    } = props;

    const classes = useStyles({});

    // NOTE need to be able to use normal props
    // if there is no formik behind the use of
    // this control.  The following call throws
    // when no formik, but still need "field"
    // to be populated, but then from regular
    // props.
    const [field] = useField({ name: props.id });

    const muiClasses = negative
        ? {
              track: classes.negativeBar,
              checked: classes.negativeChecked,
          }
        : undefined;

    return (
        <FormGroup row>
            <FormControlLabel
                className={
                    labelPlacement === "start"
                        ? classes.placementStart
                        : undefined
                }
                control={
                    <MuiSwitch
                        {...muiSwitchProps}
                        name={name}
                        classes={muiClasses}
                        checked={field.value}
                        onChange={
                            onSwitchChange ? onSwitchChange : field.onChange
                        }
                        value={field.value}
                        className={classes.switch}
                        id={id}
                        disabled={disabled}
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
        </FormGroup>
    );
};
